import { useMsalAuthContext } from './AuthContext';

export function useMsalAuth() {
  return useMsalAuthContext();
}
